"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cashInRewardMiniGame = exports.startMiniGame = exports.getMiniGame = exports.getMiniGamesList = exports.getGameImage = exports.getGame = exports.getFeatureState = exports.getFeatureConfigs = exports.getWinnersWidgetData = exports.getLeaderboards = exports.makePutReq = exports.makePostReq = exports.makeGetReq = void 0;
var isMobile_1 = __importDefault(require("../components/rubyJackpot/App/utils/isMobile"));
var queriesToString_1 = require("../components/rubyJackpot/App/utils/queriesToString/queriesToString");
var interfaces_1 = require("../interfaces");
var interfaces_2 = require("../interfaces");
var rewards_1 = require("./factories/wof/rewards");
var gamesThumbsMap_1 = __importDefault(require("./gamesThumbsMap"));
var helpers_1 = require("./helpers");
var getHeaders = function () {
    return {
        Accept: "application/json",
        // "Content-Type": "application/json",
    };
};
var makeRequestWithTimeout = function (props, timeout) {
    if (timeout === void 0) { timeout = 5000; }
    return __awaiter(void 0, void 0, void 0, function () {
        var url, method, _a, withAuth, body, _b, extraHeaders, headers, abortController, id, response, result, err_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    url = props.url, method = props.method, _a = props.withAuth, withAuth = _a === void 0 ? false : _a, body = props.body, _b = props.headers, extraHeaders = _b === void 0 ? {} : _b;
                    headers = getHeaders();
                    abortController = new AbortController();
                    id = setTimeout(function () { return abortController.abort(); }, timeout);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, {
                            method: method,
                            headers: __assign(__assign({}, headers), extraHeaders),
                            body: body,
                            signal: abortController.signal,
                        })];
                case 2:
                    response = _c.sent();
                    clearTimeout(id);
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _c.sent();
                    if (response.status >= 200 && response.status < 300) {
                        return [2 /*return*/, result];
                    }
                    return [2 /*return*/, Promise.reject(result)];
                case 4:
                    err_1 = _c.sent();
                    return [2 /*return*/, Promise.reject(err_1)];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var makeRequest = function (props) { return __awaiter(void 0, void 0, void 0, function () {
    var url, method, _a, withAuth, body, _b, extraHeaders, controller, headers, response, result, err_2;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                url = props.url, method = props.method, _a = props.withAuth, withAuth = _a === void 0 ? false : _a, body = props.body, _b = props.headers, extraHeaders = _b === void 0 ? {} : _b, controller = props.controller;
                headers = getHeaders();
                if (body instanceof FormData) {
                    // delete headers["Content-Type"];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(url, {
                        method: method,
                        headers: __assign(__assign({}, headers), extraHeaders),
                        body: body,
                        signal: controller === null || controller === void 0 ? void 0 : controller.signal,
                    })];
            case 2:
                response = _c.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                result = _c.sent();
                if (response.status >= 200 && response.status < 300) {
                    return [2 /*return*/, result];
                }
                return [2 /*return*/, Promise.reject(result)];
            case 4:
                err_2 = _c.sent();
                return [2 /*return*/, Promise.reject(err_2)];
            case 5: return [2 /*return*/];
        }
    });
}); };
var makeGetReq = function (url, withAuth, headers, controller) {
    if (withAuth === void 0) { withAuth = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, makeRequest({
                    url: url,
                    method: interfaces_1.ReqType.Get,
                    withAuth: withAuth,
                    headers: headers,
                    controller: controller,
                })];
        });
    });
};
exports.makeGetReq = makeGetReq;
var makePostReq = function (url, body, withAuth, headers, controller) {
    if (withAuth === void 0) { withAuth = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, makeRequest({
                    url: url,
                    method: interfaces_1.ReqType.Post,
                    body: body,
                    withAuth: withAuth,
                    headers: headers,
                    controller: controller,
                })];
        });
    });
};
exports.makePostReq = makePostReq;
var makePutReq = function (url, body, withAuth, withTimeout, headers, timeout, controller) {
    if (withAuth === void 0) { withAuth = false; }
    if (withTimeout === void 0) { withTimeout = false; }
    if (timeout === void 0) { timeout = 5000; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (withTimeout) {
                return [2 /*return*/, makeRequestWithTimeout({ url: url, method: interfaces_1.ReqType.Put, body: body, withAuth: withAuth, headers: headers }, timeout)];
            }
            return [2 /*return*/, makeRequest({
                    url: url,
                    method: interfaces_1.ReqType.Put,
                    body: body,
                    withAuth: withAuth,
                    headers: headers,
                    controller: controller,
                })];
        });
    });
};
exports.makePutReq = makePutReq;
// const configs = AppConfiguration.getInstance();
// const { appConfiguration } = configs;
var getLeaderboards = function (tournamentApiUrl) {
    return function (options, controller) { return __awaiter(void 0, void 0, void 0, function () {
        var url, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(tournamentApiUrl, "/features/tournament/aggregated/leaderboards").concat((0, queriesToString_1.queriesToString)(options));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, exports.makeGetReq)(url, false, {}, controller)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    err_3 = _a.sent();
                    console.error(err_3);
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.getLeaderboards = getLeaderboards;
var getWinnersWidgetData = function (winnersWidgetApiUrl) { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, (0, exports.makeGetReq)(winnersWidgetApiUrl)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                err_4 = _a.sent();
                console.error(err_4);
                return [2 /*return*/];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
exports.getWinnersWidgetData = getWinnersWidgetData;
// Ruby widget requests
var getFeatureConfigs = function (rubyApiUrl) {
    return function (urlParams) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, exports.makeGetReq)("".concat(rubyApiUrl, "/init").concat((0, queriesToString_1.queriesToString)(urlParams)))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getFeatureConfigs = getFeatureConfigs;
var getFeatureState = function (rubyApiUrl) {
    return function (urlParams) { return __awaiter(void 0, void 0, void 0, function () {
        var rush, response, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rush = false;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, exports.makeGetReq)("".concat(rubyApiUrl, "/state").concat((0, queriesToString_1.queriesToString)(urlParams)))];
                case 2:
                    response = _a.sent();
                    if (rush) {
                        return [2 /*return*/, __assign(__assign({}, response), { features: response.features.map(function (featureState) {
                                    if (featureState.featureData.jackpotType === "HourlyJackpot") {
                                        return __assign(__assign({}, featureState), { featureData: __assign(__assign({}, featureState.featureData), { startTime: featureState.featureData.endTime, endTime: featureState.featureData.endTime + 3600000 }) });
                                    }
                                    return featureState;
                                }) })];
                    }
                    return [2 /*return*/, response];
                case 3:
                    e_2 = _a.sent();
                    console.error(e_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.getFeatureState = getFeatureState;
var getGame = function (code) {
    if (gamesThumbsMap_1.default.has(code)) {
        return gamesThumbsMap_1.default.get(code);
    }
    return gamesThumbsMap_1.default.get("sw_bb");
};
exports.getGame = getGame;
var getGameImage = function (rubyCdnDomain) {
    return function (code) {
        // const { rubyCdnDomain } = appConfiguration;
        var game = (0, exports.getGame)(code);
        if ((0, isMobile_1.default)()) {
            return "".concat(rubyCdnDomain, "/mobile/images/games/provider-id-76/").concat(game.codeName, ".png");
        }
        else {
            return "".concat(rubyCdnDomain, "/desktop/images/games/provider-id-76/").concat(game.codeName, ".png");
        }
    };
};
exports.getGameImage = getGameImage;
var getMiniGamesList = function (miniGamesApi) {
    return function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, exports.makeGetReq)("".concat(miniGamesApi, "/features/minigame").concat((0, queriesToString_1.queriesToString)(options)))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_5 = _a.sent();
                    console.error(err_5);
                    return [2 /*return*/, err_5];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getMiniGamesList = getMiniGamesList;
var getMiniGame = function (miniGamesApi) {
    return function (gameId, options) { return __awaiter(void 0, void 0, void 0, function () {
        var err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, exports.makeGetReq)("".concat(miniGamesApi, "/features/minigame/").concat(gameId).concat((0, queriesToString_1.queriesToString)(options)))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_6 = _a.sent();
                    console.error(err_6);
                    return [2 /*return*/, err_6];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getMiniGame = getMiniGame;
var startMiniGame = function (miniGamesApi) {
    return function (gameId, options, useMock) {
        if (useMock === void 0) { useMock = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (useMock) {
                            return [2 /*return*/, (0, rewards_1.createRewardsOnPlayReq)(5)];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, exports.makeGetReq)("".concat(miniGamesApi, "/features/minigame/").concat(gameId, "/start").concat((0, queriesToString_1.queriesToString)(options)))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_7 = _a.sent();
                        console.error(err_7);
                        return [2 /*return*/, err_7];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
};
exports.startMiniGame = startMiniGame;
var cashInRewardMiniGame = function (miniGamesApi) {
    return function (data, rewards, useMock) {
        if (useMock === void 0) { useMock = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var rewardIndex, timeout, err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (useMock) {
                            rewardIndex = (0, helpers_1.getRandomIndex)(rewards.length);
                            return [2 /*return*/, __assign({}, (0, rewards_1.createCashedInRewards)({
                                    rewardType: interfaces_2.MiniGamesRewardTypes.Bonus,
                                    rewardId: rewards[rewardIndex].id,
                                }))];
                        }
                        timeout = 20 * 1000;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, exports.makePutReq)("".concat(miniGamesApi, "/features/minigame/action"), JSON.stringify(data), false, true, {
                                "Content-Type": "application/json",
                            }, timeout)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_8 = _a.sent();
                        console.error(err_8);
                        return [2 /*return*/, Promise.reject(err_8)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
};
exports.cashInRewardMiniGame = cashInRewardMiniGame;
